import React, { Component } from 'react'

export default class Footer extends Component {
  render() {

    return (
      <footer>
        <p><strong>Version:</strong> {process.env.REACT_APP_VERSION}, <strong>Page updated:</strong> 2022, <strong>Developer:</strong> Lauren Oaklands<br/>
        <strong>Icons:</strong> fontawesome-pro-5.0.10 &#47; Light &#47; Brands, <strong>Updated:</strong> 15/02/2019<br/>
        <strong>Images:</strong> Ricardo Gomez, Adrian Olichon, Brian Patrick, Ruben Ramirez and Tomas Jasovsky on Unsplash</p>
		  </footer>
    )
  }
}